import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.444 15.960 C 3.203 21.805,1.360 26.605,1.348 26.627 C 1.337 26.649,2.358 26.667,3.618 26.667 L 5.909 26.667 6.640 24.707 C 7.042 23.629,7.419 22.621,7.476 22.467 L 7.581 22.187 11.865 22.187 L 16.148 22.187 16.960 24.366 C 17.406 25.565,17.789 26.573,17.809 26.607 C 17.837 26.651,18.458 26.664,20.115 26.654 L 22.384 26.640 18.299 15.987 L 14.213 5.334 11.865 5.334 L 9.518 5.333 5.444 15.960 M18.027 5.373 C 18.027 5.395,19.859 10.189,22.098 16.027 L 26.170 26.640 28.422 26.654 C 29.660 26.662,30.664 26.650,30.652 26.627 C 30.640 26.605,28.797 21.805,26.556 15.960 L 22.482 5.333 20.254 5.333 C 19.029 5.333,18.027 5.351,18.027 5.373 M13.308 14.587 C 14.021 16.493,14.621 18.095,14.641 18.147 C 14.676 18.235,14.523 18.240,11.867 18.240 C 9.211 18.240,9.057 18.235,9.091 18.147 C 9.111 18.095,9.723 16.457,10.453 14.507 C 11.182 12.556,11.797 10.913,11.819 10.855 C 11.871 10.722,11.738 10.389,13.308 14.587 ",
      stroke: "none",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }